import(/* webpackMode: "eager" */ "/var/task/sourcecode/src/app/global-error.tsx");
